import React, { Suspense } from 'react';

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../modules/cookie/cookie");
import { Details } from "../../components/Details/details";

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main">
                <Details />
            </div> 
        </Suspense>
    );
}

export default App;